import { render, staticRenderFns } from "./no_play.vue?vue&type=template&id=b4ce5118&scoped=true&"
import script from "./no_play.vue?vue&type=script&lang=js&"
export * from "./no_play.vue?vue&type=script&lang=js&"
import style0 from "./no_play.vue?vue&type=style&index=0&id=b4ce5118&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ce5118",
  null
  
)

export default component.exports